export enum PublicRoutes {
  Home = '',
  Signup = 'signup',
  Signin = 'signin',
  Otp = 'Otp',
  changeMdp = 'MotDePasseOublie'
}
